import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type { IHistoryOfAdminFeesChanges } from '../types';
import {
  AFFILIATE_PROGRAM_ADMIN_FEES_HISTORY_LIST_API_URL,
  AFFILIATE_PROGRAM_ADMIN_FEES_HISTORY_LIST_QUERY_KEY,
  AFFILIATE_PROGRAM_ADMIN_FEES_PERMISSIONS,
} from '../constants';

export default function useHistoryOfAdminFeesQuery(): IContextQueryResult<IHistoryOfAdminFeesChanges> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IHistoryOfAdminFeesChanges>({
    queryKey: [AFFILIATE_PROGRAM_ADMIN_FEES_HISTORY_LIST_QUERY_KEY],
    queryFn: ({ signal }) => fetchGet<IHistoryOfAdminFeesChanges>(
      AFFILIATE_PROGRAM_ADMIN_FEES_HISTORY_LIST_API_URL,
      {
        signal,
        permission: AFFILIATE_PROGRAM_ADMIN_FEES_PERMISSIONS.SHOW,
      },
    ),
  });
}
